export default __webpack_public_path__ + "static/media/x-hero.dd7d69a1.svg";